// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__Xzz-M","cancel":"Button_cancel__1VIlk","submit":"Button_submit__1yfhG"};